// extracted by mini-css-extract-plugin
module.exports = {"titleDetail":"y-","header":"y_","headerUnderTrailer":"za","leftHeader":"zb","buttonsWrapper":"zc","rightHeader":"zd","rentalBadge":"ze","rentalNotesFrame":"zf"};